import { MDBCard, MDBCardBody, MDBCardHeader, MDBCardImage, MDBCol, MDBRow } from "mdb-react-ui-kit";
// import React from "react";

interface our_advisor{

    img:string
    name:string
    position:string 
    body:Array<string>

}

const our_advisor_list:Array<our_advisor> = [ 
    {
        img:'../../../our_board_of_advisor_pics/advisor_1.jpeg',
        name:'Prof. Michael Adu Osei',
        position:'',
        body: [
            'A professor in Crop Physiology, Department of Crop Science, University of Cape Coast, Ghana. '
        ]
    },
    {
        img:'../../../our_board_of_advisor_pics/advisor_2.jpeg',
        name:'Prof. Paul Agu Asare',
        position:'',
        body: [
            'A proferssor in Plant Breeding, Department of Crop Science, University of Cape Coast, Ghana.'
        ]
    },
    {
        img:'../../../our_board_of_advisor_pics/advisor_3.jpeg',
        name:'Dr. Lawrence Misa Aboagye',
        position:'',
        body: [
            'former director, CSIR- Plant Genetic Resources Research Institute, Bunso, Ghana.'
        ]
    }
]

export function OurBoardOfAdvisor() {

    return (
        <>
            <MDBCard className={'border border-0 border-danger shadow-5'}>
                <MDBCardHeader>OUR BOARD OF ADVISORS</MDBCardHeader>
                <MDBCardBody>
                    <MDBRow className={'border border-0 border-danger gy-3'}>
                        {our_advisor_list.map(
                            (advisor, index) => (
                                <MDBCol key={index} className={'border border-0 border-danger'} lg={4}>
                                    <MDBCard className={'border border-0 border-danger shadow-0'}>
                                        <MDBCardImage style={{ height: '400px' }} src={advisor.img !== '' ? `${advisor.img}` : '../../../user.png'} alt='...' position='top' />
                                        <MDBCardBody>
                                            <p>
                                                <span className={'fw-bold'}>{advisor.name}</span><br />
                                                <span className={'fw-normal'}>{advisor.position}</span>
                                            </p>
                                            {advisor.body.map(
                                                bdy => <p className={'fw-light'}>{bdy}</p>
                                            )}
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBCol>
                            )
                        )}
                    </MDBRow>
                </MDBCardBody>
            </MDBCard>
        </>
    )
}